export default __webpack_public_path__ + "static/media/delegates__cards-list-item-icon-1.b912a300.svg";